import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  Aangifte, BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity,
  JaarruimteGegevens
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-jaarruimtegegevens',
  templateUrl: './jaarruimtegegevens.component.html',
  styleUrls: ['./jaarruimtegegevens.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class JaarruimtegegevensComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
  private clientEntitySubscription: Subscription | undefined;
  private isDefAangifteSubscription: Subscription | undefined;
  private isSaving = false;
  @Input() public id!: string;
  public clientId!: string;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;

  public partnerBoolean = {} as boolean;
  @Input() partner = new BehaviorSubject<boolean>(false);
  private partnerAangifte = {} as Aangifte;

  public isDefAangifte = {} as boolean;
  public jaar = 2024;

  private focusedElementId: string | null = null;

  public jaarruimtes = {} as FormGroup;
  public jaarRuimteJaar: SelectFormControlItem<number>[] = [];
  public reserveringsRuimtenJaren: SelectFormControlItem<number>[] = [];

  constructor(
    public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
    private router: Router,
    private fb: FormBuilder,
  ) {
    this.jaarruimtes = this.fb.group({
      jaarruimteGegevens: this.fb.array<JaarruimteGegevens>([]),
    });
  }

  get jaarruimteGegevens(): FormArray {
    return this.jaarruimtes.get('jaarruimteGegevens') as FormArray;
  }

  addRijJaarruimteGegevens(): void {
    this.jaarruimteGegevens.push(this.createJaarruimteGegevensFormGroup());
  }

  verwijderRijJaarruimteGegevens(index: number): void {
    this.jaarruimteGegevens.removeAt(index);
    this.jaarruimtes.updateValueAndValidity()
    this.jaarruimtes.markAsDirty()
    this.saveForm();
  }

  createJaarruimteGegevensFormGroup(gegevens?: JaarruimteGegevens): FormGroup {
    return this.fb.group<JaarruimteGegevens>({
      jaar: gegevens ? gegevens.jaar : Number(new Date().getFullYear() - 1),
      winstUitOnderneming: gegevens ? gegevens.winstUitOnderneming : undefined,
      toevoegingFor: gegevens ? gegevens.toevoegingFor : undefined,
      afnemingFor: gegevens ? gegevens.afnemingFor : undefined,
      belastbaarLoon: gegevens ? gegevens.belastbaarLoon : undefined,
      belastbaarROW: gegevens ? gegevens.belastbaarROW : undefined,
      belastbarePU: gegevens ? gegevens.belastbarePU : undefined,
      factorA: gegevens ? gegevens.factorA : undefined,
      premiesNettoPensioen: gegevens ? gegevens.premiesNettoPensioen : undefined,
      afgetrokkenPremie: gegevens ? gegevens.afgetrokkenPremie : undefined,
    } as JaarruimteGegevens);
  }

  public ngOnInit(): void {
    this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
      this.isDefAangifte = isDefAangifte;
    });
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        const aangifte = incomeTaxEntity.aangifte;
        this.aangifte = aangifte;
        this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : ({} as Aangifte);
        this.updateForm();
        this.partner.subscribe((partner) => {
          this.partnerBoolean = partner;
            this.jaarruimtes.reset();
            this.updateForm();
        });
        if (incomeTaxEntity.year !== undefined) {
          this.jaar = incomeTaxEntity.year;
        }
        this.jaarRuimteJaar = [
          {
            value: this.aangifte.aangifteJaar,
            label: this.aangifte.aangifteJaar.toString(),
          },
        ];
        this.reserveringsRuimtenJaren = [
          {
            value: this.aangifte.aangifteJaar - 10,
            label: (this.aangifte.aangifteJaar - 10).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 9,
            label: (this.aangifte.aangifteJaar - 9).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 8,
            label: (this.aangifte.aangifteJaar - 8).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 7,
            label: (this.aangifte.aangifteJaar - 7).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 6,
            label: (this.aangifte.aangifteJaar - 6).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 5,
            label: (this.aangifte.aangifteJaar - 5).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 4,
            label: (this.aangifte.aangifteJaar - 4).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 3,
            label: (this.aangifte.aangifteJaar - 3).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 2,
            label: (this.aangifte.aangifteJaar - 2).toString(),
          },
          {
            value: this.aangifte.aangifteJaar - 1,
            label: (this.aangifte.aangifteJaar - 1).toString(),
          },
        ] as SelectFormControlItem<number>[];
      }
    });
    this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
      this.clientId=client.sstRelationId!;
    });
    this.routerSubscription = this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
    if (this.isDefAangifteSubscription) {
      this.isDefAangifteSubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.jaarruimtes.dirty
  }

  private updateForm(): void {
    let jaarruimteGegevensLijst =
      this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.jaarruimteGegevensPerJaar || [];
    this.partner.subscribe((partner) => {
      if (partner) {
        jaarruimteGegevensLijst =
          this.aangifte?.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.jaarruimteGegevensPerJaar || [];
      }
    });

    const formArray = this.jaarruimtes.get('jaarruimteGegevens') as FormArray;
    const focusedControl = this.focusedElementId ? (document.getElementById(this.focusedElementId) as HTMLElement) : null;
    while (formArray.length > jaarruimteGegevensLijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < jaarruimteGegevensLijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(jaarruimteGegevensLijst[i]);
      } else {
        const formGroup = this.createJaarruimteGegevensFormGroup(
          jaarruimteGegevensLijst[i],
        );
        formArray.push(formGroup);
      }
    }

    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    setTimeout(() => {
      this.partner.subscribe((partner) => {
        if (!partner) {
          this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            box1: {
              ...this.aangifte.box1,
              uitgavenVoorInkomensvoorzieningen: {
                ...this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen,
                jaarruimteGegevensPerJaar:
                  this.jaarruimtes.value.jaarruimteGegevens,
              },
            },
          } as Aangifte;
          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
          this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            partnerAangifte: {
              ...this.aangifte.partnerAangifte,
              box1: {
                ...this.aangifte.partnerAangifte?.box1,
                uitgavenVoorInkomensvoorzieningen: {
                  ...this.aangifte.partnerAangifte?.box1
                    ?.uitgavenVoorInkomensvoorzieningen,
                  jaarruimteGegevensPerJaar:
                    this.jaarruimtes.value.jaarruimteGegevens,
                },
              },
            },
          } as Aangifte;
          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
      });
      this.jaarruimtes.markAsDirty()
    }, 0);
  }
}
